import styled from 'styled-components';

export default styled.section`
  .container {
    padding: 16px 32px;
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      margin-top: 16px;
      flex-wrap: wrap;
      button.btn {
        height: 24px;
        padding: 0;
        font-size: 12px;
        letter-spacing: 0;
        line-height: 18px;
      }
      .box-action {
        .btn-delete {
          margin-right: 16px;
        }
      }
    }
    .list-image {
      padding: unset;
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      .list-image-item {
        margin: 1px;
        display: inline-flex;
      }
    }
  }
`;
